import {  Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { URLS } from '../../core/services/apiurls.constants';
import { AuthLoginService } from 'src/app/auth/auth-login.service';


@Injectable({ providedIn: 'root' })
export class CommonService {
 
  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
  };



  constructor(private http: HttpClient, private loginservice: AuthLoginService) { }
 
  private message = new BehaviorSubject('');
  public cco_med = new BehaviorSubject<any>(null);
  private document = new BehaviorSubject<any>('');
  private letterID = new BehaviorSubject('');
  private picChange = new BehaviorSubject('');
  private ccolifePlan = new BehaviorSubject('');
  private temp = new BehaviorSubject('');
  private email = new BehaviorSubject('');
  private pw = new BehaviorSubject('');
  public openform = new BehaviorSubject<any>('');
  public validateform = new BehaviorSubject<any>('');
  public formId = new BehaviorSubject<any>('');
  public isCCO = new BehaviorSubject<any>('');
  public loggout = new BehaviorSubject<any>('');
  public PDStatus = new BehaviorSubject<any>('');
  public consentUpdate = new BehaviorSubject<any>('');
  public mailmergesign = new BehaviorSubject<any>('');

  statuspacket = this.PDStatus.asObservable();
  UploadDoc = this.document.asObservable();
  sharedList = this.message.asObservable();

 
  TempId = this.formId.asObservable();
  profile = this.document.asObservable();
  cco = this.ccolifePlan.asObservable();
  value = this.temp.asObservable();
  mail = this.email.asObservable();
  password = this.pw.asObservable();
  validateforms = this.validateform.asObservable();
  openforms = this.openform.asObservable();
  isCCOEnabled = this.isCCO.asObservable();
  loggOut = this.loggout.asObservable();
  consent = this.consentUpdate.asObservable();
  mailsign = this.mailmergesign.asObservable();

  private buttonClickSubject = new Subject<void>();
  buttonClick$ = this.buttonClickSubject.asObservable();

  triggerButtonClick(): void {
    this.buttonClickSubject.next();
  }
  private countSubject = new BehaviorSubject<any>([]); 
  count$ = this.countSubject.asObservable(); 

  updateCount(count: any) {
    this.countSubject.next(count); 
  }
  setLogoutType(type: string): void {
    this.loggout.next(type);
  }

  token() {
    return this.loginservice.getToken();
  }


  mailmergesignpreview(sign:any){
    this.mailmergesign.next(sign);
  }

  nextList(message: any) {
    this.message.next(message);
  }
  medList(medicationlist:any){
   this.cco_med.next(medicationlist);
  }
  
 
  fromLogout(logoutValue: any) {
    this.loggout.next(logoutValue)
  }

  emailAddress(email: any) {
    this.email.next(email);
  }

  pWord(pw: any) {
    this.pw.next(pw);
  }

  sharedValue(temp: any) {
    this.temp.next(temp);
  }

  packetforms(open: any) {
    this.openform.next(open);
  }

  consentForm(form : any){
    this.consentUpdate.next(form);
  }

  packetdetailsstatus(status: any) {
    this.PDStatus.next(status);
  }

  CCOEnabled(isCCO: any) {
    this.isCCO.next(isCCO);
  }

  validatepacketforms(validate: any) {
    this.validateform.next(validate);
  }

  clearMemory() {
    this.document.next(null);
  }

  clearvalue() {
    this.openform.next(null);
  }

  letterTemp(letterID: any) {
    this.formId.next(letterID);
  }
  ccoPlan(letterID: any) {
    this.ccolifePlan.next(letterID);
  }
  profilePic(picChange: any) {
    this.message.next(picChange);
  }

  docUpload(document: any) {
    this.document.next(document);
  }

  TimeZone() {
    let offset = new Date().getTimezoneOffset();
    return offset;
  }

  BillPay(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.OnlinePayment.createpayment, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  WaysterPay(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.OnlinePayment.wayster_insert, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  MFAAuth(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.MFA, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetProfile(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.profile, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  SwitchClient(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.switchclient, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  //print
  print(clientId: any, offset: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.print + clientId + '&offset=' + offset + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }



  GetPacketForms(token: any, clientid: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PacketsForms.AvaliableForms + clientid + '&SchemaName=' + token, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  UpdatePacketStatus(status: string, fDetailID: any, formid: any, action: any, packetDetailId: any, token: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PacketsForms.UpdateStatus + status + '&FormDetailID=' + fDetailID + '&FormID=' + formid + '&Action=' + action + '&PacketDetailID=' + packetDetailId + '&SchemaName=' + token, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetDashboardCounts(ClientId: number, offset: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.DashBoard.getDashboardCounts + ClientId + '&offset=' + offset + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetTodos(ClientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.DashBoard.gettodos + ClientId + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetAppointments(ClientId: number, offset: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.DashBoard.getAppointments + ClientId + '&offset=' + offset + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  ChangePassword(editedValue: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.changepassword, editedValue, this.httpOptions).pipe(
      map((res) => {
        // return res as any;
        return res;
      })
    )
  }

  CheckCompanyCode(email: any, CompanyCode: any, action: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.checkcompanycode + '?Email=' + email + '&CompanyCode=' + CompanyCode + '&Action=' + action, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  CheckEmail(Email: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.checkemail + Email + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  CreateProfile(createuser: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.createProfile, createuser, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

 countybordform(payload: any) {
        return this.http.post(URLS.GOBAL_URL + URLS.Profile.createFCBDDApplication, payload, this.httpOptions).pipe(
          map((res) => res)
        );
      }

  insertProfilePic(saveDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.insertClientProfile, saveDetails, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  refreshToken(token: string) {
    sessionStorage.setItem('access_token', JSON.stringify(token));
  }


  AppointmentsList(ClientId: number, offset: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getappointments + ClientId + '&offset=' + offset + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  NewSecureMessage(msgload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.insertsecuremessage, msgload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  AuditNewSecureMessage(msgload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.auditsecuremessageinsert, msgload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  SecureMessage(clientId: number, type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.SecureMessage.securemessage + clientId + '&Type=' + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  secureMessageDocument(documentId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.SecureMessage.secureMessageDocument + documentId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  UpdateSentMessage(editmsg: any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.SecureMessage.updatesentmessage, editmsg, this.httpOptions
      ).pipe(
        map((res) => {
          return res;
        })
      );
  }

  updateSecureMessageread(messageId: number, isread: boolean) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.SecureMessage.updateSecureMessagesread + messageId + '&isread=' + isread + '&SchemaName=' + this.token(),
        this.httpOptions
      )  .pipe(map((res) => {
          return res;
        })
      );
  }

  ReplySecureMessage(clientId: number, type: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.replysecuremessage + clientId + '&Type=' + type + '&SchemaName=' + this.token()
      , this.httpOptions)
      .pipe
      (map((res) => {
        return res;
      })
      );
  }
  DeleteSecureMessage(msgID: number){
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.deletesecuremessage + msgID + '&SchemaName=' + this.token()
    , this.httpOptions).pipe(map((res) => {
      return res
    }))
  }

  DeleteAuditSecureMessage(payload:any){
    return this.http.post(URLS.GOBAL_URL + URLS.SecureMessage.auditsecuremessagedelete,payload
    , this.httpOptions).pipe(map((res) => {
      return res
    }))
  }
  GetTaskDetails(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Task.taskdetails + clientId + '&SchemaName=' + this.token()
      , this.httpOptions).pipe(map((res) => {
        return res
      }))
  }
  UpdateTaskDetails(editvalue: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Task.taskUpdatedetails, editvalue, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  
  get getAdditionalHeaders(): string {
    const additionalHeaders = JSON.stringify({
      Offset: '',
      Timezone: '',
      IPAddress: '',
    });
    return additionalHeaders;
  }

  GetProblemList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getproblemList + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return err;
        })
      );
  }

  GetMedicationList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getmedicationList + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetMedicationScheduleList(clientId: number, medicationListId: number): Observable<any> {
    const url =
      URLS.GOBAL_URL +
      URLS.Health_Record.GetScheduleMedicationList +
      clientId +
      '&MedicationListID=' + medicationListId +  // Add MedicationListID to the URL
      '&SchemaName=' + this.token(); // Assuming token() returns the schema name
  
    return this.http.post(url, this.httpOptions).pipe(
      map((res: any) => {
        return res; // Return the API response
      })
    );
  }
  

  GetCCoAllergies(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.ccoLifePlan.ccoAllergies + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetNonAllergyList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getnonallergylist + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetAllergyList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getallergylist + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetDocumentList(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getdocumentlist + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }


  getById(id: string) {

    return this.http.get(URLS.GOBAL_URL + URLS.Surveys.getClinicalSurveys + id);

  }

  GetClinicalSurveyList(clientId: number, surveyId: any) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Surveys.getClinicalSurveys + clientId + '&UD_ClinicSatisfactionSurveyID=' + surveyId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetGad7(clientId: any, gadId: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getgad7 + clientId + '&GAD7ID=' + gadId + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  TemplateGad(clientId: number, type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.gad7api.template_details + clientId + '&Type=' + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetClinicalSurveyTemplateDetails(clientId: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Surveys.getSurveyTemplateDetails + clientId + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  GetLabResult(clientId: number) {
    return this.http.post(
      URLS.GOBAL_URL + URLS.Health_Record.getlabresults + clientId + '&SchemaName=' + this.token(),
      this.httpOptions
    )
      .pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetImmunization(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getimmunization + clientId + '&SchemaName=' + this.token()
      , this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetEncounterList(clientId: number, offset: number) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Health_Record.getencounters + clientId + '&offset=' + offset + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  GetSmokingList(clientId: number, offset: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getsmokingstatus + clientId + '&offset=' + offset
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(map((res) => {
        return res;
      })
      )
  }
  GetTreatmentPlan(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.gettreatment + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(map((res) => {
        return res;
      }))
  }
  GetNursing(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getnursing + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(map((res) => {
        return res;
      }))
  }
  GetDietOrder(ClientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getdietorder + ClientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetVitalSign(ClientId: number, offset: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getvitalsign + ClientId + '&offset=' + offset
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetDiagnosis(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getdiagnosis + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetContact(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getcontacts + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetLifePlan(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getlifePlan + clientId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetProfileImage(clientId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.profileImage, clientId, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  GetMyTeam(clientid: any, type: string, token: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.MyTeam.myteam + clientid + '&Type=' + type
      + '&SchemaName=' + token, this.httpOptions).pipe(
        map((res => {
          return res;
        }))
      )
  }

  DocType(Clientid: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.doctype + Clientid
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }

  UpDocList(Clientid: number, email: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.getupdoc + Clientid + '&portalUserID=' + email
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }

  UpdateDocList(editload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.updatedoc, editload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  NewUpload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.insertdoc, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  AuditNewDocUpload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.auditdocinsert, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  DeleteAuditDocList(payload:any){    
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.auditdocdelete , payload,this.httpOptions).pipe(
      map((res:any)=>{
        return res;
      })
    )
  }
  DeleteDocList(clientdocID:any){    
    return this.http.post(URLS.GOBAL_URL + URLS.UploadDoc.deletedoc + '?SchemaName=' + this.token(), clientdocID, this.httpOptions).pipe(
      map((res:any)=>{
        return res;
      })
    )
  }

  SaveNewMail(saveDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.savemail, saveDetails, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  saveNewSurvey(saveSurvey: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Surveys.saveNewSurvey, saveSurvey, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }

  saveNewGad(savegad7: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.gad7api.insertgap7, savegad7, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }

  EditMail(editvalue: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.editmail, editvalue, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  editSurvey(editvalue: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Surveys.editSurveys, editvalue, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  DeleteMail(letterId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.deletemail + letterId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }

  DeleteSurvey(surveyId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Surveys.deleteClinicalSurvey + surveyId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )

  }
  GetSelectTemplates(CompanyID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.getmail + CompanyID + '&ClientID=' + this.loginservice.clientid()
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetMailTemplate(CompanyID: number, tempID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.gettemplate + CompanyID + '&ClientID=' + this.loginservice.clientid() + '&MailMergeTemplateID=' + tempID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

 
  GetMailID(ClientID: any, letterTemplateID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.maildetailID + ClientID + '&LetterTemplateID=' + letterTemplateID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }
  GetMailList(ClientID: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.MailMerge.maildetails + ClientID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }



  RequestApointment(ClientID: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.requestAppointment + ClientID
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }


  GetTimeZone(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.getTimeZone, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )

  }

  SaveAppointment(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.saveAppointment, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  
  AuditRequestAppointment(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.auditrequestAppointment, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  UnAvailTime(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.RequestAppointment.unavailtime, payload, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  CompanyLogo(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.companylogo, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  GetSecurityQA(credentials: any) {
    console.log("credentials=", credentials)
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.getSecurityQA, credentials, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  ForgotPassword(newPassword: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.forgotpassword, newPassword, this.httpOptions).pipe(
      map((res) => {
        // return res as any;
        return res;
      })
    )
  }

  CreatePreAdmission(createprofile: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.createPreAdmission, createprofile, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  AddClient(addClients: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.addClient, addClients, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }


  DueAmount(ClientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.OnlinePayment.dueAmount + ClientId + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res;

      })
    )
  }

  GetSecurityQuestion(clientId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.getSecurityQuestion, clientId, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  getBroadcastMessage(companyCode: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.broadcastMessage + companyCode + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  ccologout(clientId: any, logoutDateTime: any, email: any,AuditId:any ) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.portalLogout + clientId + '&Email=' + email + '&LogoutDateTime=' + logoutDateTime + '&SchemaName=' + this.token() + '&AuditId='+AuditId, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

 

  logout(clientId: any, logoutDateTime: any, email: any ) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.portalLogout + clientId + '&Email=' + email + '&LogoutDateTime=' + logoutDateTime + '&SchemaName=' + this.token() , this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
 
  Statement(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.OnlinePayment.clientStatement, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  getPdfs(clientId: number) {
    return this.http.post(URLS.GOBAL_URL + URLS.DashBoard.getPdf + clientId + '&SchemaName=' + this.token(), this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetccoLifePlan(clientid: number, status: string, token: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.ccoLifePlan + clientid + '&Status=' + status
      + '&SchemaName=' + token, this.httpOptions).pipe(
        map((res => {
          return res;
        }))
      )
  }

  GetccoContact(clientid: number, companyId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.getContactDetail + clientid + '&CompanyId=' + companyId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res => {
          return res;
        }))
      )
  }


  CCOPortalDocumentUpload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.GetCCOPortalDocumentUpload, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }
  NewCCODocumentUpload(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.insertCCODocumentUpload, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  DeleteCCODocList(clienttrackingID: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.deleteCCODoc + '?SchemaName=' + this.token(), clienttrackingID, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      })
    )
  }



  GetccoLifePlanUserType(clientId: number, email: any, lifePlanId: any, documentVid: any, token: string) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.getccoUserType + clientId + '&Email=' + email + '&LifePlanID=' + lifePlanId + '&DocumentVersionID=' + documentVid + '&SchemaName=' + token, this.httpOptions).pipe(
      map((res => {
        return res;
      }))
    )
  }

  GetccoLifePlanPdf(lifePlanDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.getccoLifePlanPdf, lifePlanDetails, this.httpOptions).pipe(
      map((res => {
        return res;
      }))
    )
  }

  GetccoLifePlanApproval(approvalDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.ccoLifePlanApproval, approvalDetails, this.httpOptions).pipe(
      map((res => {
        return res;
      }))
    )
  }

  AuditccoLifePlanApproval(approvalDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.ccoLifePlan.auditccoLifePlanApproval, approvalDetails, this.httpOptions).pipe(
      map((res => {
        return res;
      }))
    )
  }
  clientSignupData(base64Str: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.signUpData, base64Str, this.httpOptions).pipe(
      map((res) => {
        return res;
      })
    )
  }

  GetSigninPage(companyCode: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SSO.GetUrl, companyCode, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  GetAuthUser(loginDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SSO.GetUser, loginDetails, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  GetAuthGenerateOtp(userDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SSO.GetAuthOtp, userDetails, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  GetUserClient(userDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.getUserClient, userDetails, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  updatePortalConsent(payloadDetails: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.updatePolicy, payloadDetails, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  verifyToken(token: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.SSO.VerifyToken, token, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetPhqData(clientId: number, phqId: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Health_Record.getPhq + clientId + '&PHQID=' + phqId
      + '&SchemaName=' + this.token(), this.httpOptions).pipe(
        map((res) => {
          return res;
        })
      )
  }

  GetPhqOPtions(clientId: number, type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.PHQ9.getPhqOptions + clientId + '&Type=' + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  NewPhq(msgload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PHQ9.insertPhq, msgload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }

  GetCompletedPacket(payload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.PacketsForms.GetPacketforms, payload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
  GetSBHVital(clientId: any, SBHVitalID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getSolaceVital + clientId + '&UD_SolaceVitalSignsID=' + SBHVitalID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetAUDIT(clientId: any, auditID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getAudit + clientId + '&AuditID=' + auditID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetAims(clientId: any, aimsID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getAims + clientId + '&AimsID=' + aimsID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  Getmadrs(clientId: any, madrsID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getMadrs + clientId + '&UD_MADRSID=' + madrsID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetPtsd(clientId: any, ptsdID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getPtsd + clientId + '&UD_PTSDScreeningID=' + ptsdID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetBinge(clientId: any, BingeID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getBinge + clientId + '&UD_BINGEEATINGSCALEID=' + BingeID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetBocs(clientId: any, BcosID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getBocs + clientId + '&UD_YBOCSID=' + BcosID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }

  GetAuditOPtions(type: string) {
    return this.http
      .post(
        URLS.GOBAL_URL + URLS.Audit.getAuditOptions + type + '&SchemaName=' + this.token(),
        this.httpOptions
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  NewSBHVital(SBHVitals: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.SBHVitalapi.insertVital, SBHVitals, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewAudit(Audit: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Audit.insertAudit, Audit, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewAims(Aims: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Aims.InsertAimsAPI, Aims, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewMadrs(Madrs: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.Madrs.InsertMadrsAPI, Madrs, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewPtsd(ptsd: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.ptsd.InsertPtsdAPI, ptsd, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )



  }
  NewBinge(binge: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.BingeScale.InsertBinge, binge, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }
  NewBocs(ybocs: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.ybocsScale.InsertBocs, ybocs, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )
  }
  GetHamilton(clientId: any, hamID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.gethamilton + clientId + '&UD_HamiltonAnxietyScaleID=' + hamID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetPrepProv(clientId: any, provID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getprepprov + clientId + '&UD_AppointmentPrepProviderID=' + provID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetPrepTherapy(clientId: any, therapyID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getpreptherapy + clientId + '&UD_AppointmentPrepTherapyID=' + therapyID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetDisorderScale(clientId: any, provID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getDisorder + clientId + '&UD_MoodDisorderScaleID=' + provID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  GetSleepScale(clientId: any, SLeepID: any) {
    return this.http
      .post(URLS.GOBAL_URL + URLS.Health_Record.getSleep + clientId + '&UD_EpworthSleepinessscaleID=' + SLeepID + "&SchemaName=" + this.token(),
        this.httpOptions)
      .pipe(map((res) => {
        return res;
      }))
  }
  NewHmailton(hamilton: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.hemilton.InsertHamilton, hamilton, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  Newprovider(provider: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.prepProvider.InsertProvider, provider, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewTherapy(therapy: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.prepTherapy.InsertTherapy, therapy, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewDisorder(therapy: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.DisorderScale.InsertDisorder, therapy, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }
  NewSleepScale(therapy: any) {
    return this
      .http.post(URLS.GOBAL_URL + URLS.SleepScale.InsertSleep, therapy, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        })
      )


  }

  AuditLogData(msgload: any) {
    return this.http.post(URLS.GOBAL_URL + URLS.Profile.auditlog, msgload, this.httpOptions).pipe(
      map((res) => {
        return res
      })
    )
  }
}

